export default __webpack_public_path__ + "static/media/05.93f37bd9.png";